export default {
  content: null,
  status: "inited"
};
